import { FC, useEffect, useState } from "react";
import { Container, Content, TableContainer } from "../style";
import { SummaryTableSelector } from "./TableSelector";
import { SummaryTableDto } from "../../../types/stats/summaryTables";
import { getSummaryTable } from "../../../api/transport/statsTransport";
import { Loader } from "../../../components/Loader";
import { TournamentTable } from "../../../components/TournamentTable";
import { Link } from "../../../components";
import { setDocumentTitle } from "../../../utils";

export const SummaryTablesPage: FC = () => {
    const [selectedTableId, setSelectedTableId] = useState<number>();
    const [summaryTable, setSummaryTable] = useState<SummaryTableDto>();
    const [loading, setLoading] = useState(true);
    const onTableSelect = (summaryTableId: number) => {
        setSelectedTableId(summaryTableId);
        if (summaryTableId !== selectedTableId) {
            window.history.pushState({}, '', `?shows=${summaryTableId}`);
        }
    }

    useEffect(() => {
        setLoading(true);
        if (!selectedTableId) {
            return;
        }
        getSummaryTable(selectedTableId).then((data) => {
            setSummaryTable(data);
            setDocumentTitle(`${data.name} - Общий зачёт - Официальный сайт Академия «Родина»`);
        }).finally(() => {
            setLoading(false)
        });
    }, [selectedTableId]);

    useEffect(() => {
        setDocumentTitle(`Общий зачёт - Официальный сайт Академия «Родина»`);
    }, []);

    return (
        <div className="p-2 sm:p-3 max-w-[1024px] mx-auto">
            <div className="flex flex-col items-center gap-2">
                <SummaryTableSelector onSelect={onTableSelect} />
                <div className="flex flex-row gap-2 w-full flex-wrap items-center justify-center">
                    {summaryTable?.tournaments.map((t) => (
                        <Link
                            to={t.url}
                            key={t.id}
                            className="max-w-full text-center flex items-center justify-center transition-all bg-slate-200 px-3 py-1 sm:px-4 sm:py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm"
                        >
                            {t.name}
                        </Link>
                    ))}
                </div>
            </div>
            <Content>
                <TableContainer>
                    <div className="relative min-h-96">
                        {loading && (
                            <div className="absolute top-0 bottom-0 left-0 right-0 z-50 bg-white bg-opacity-75">
                                <Loader />
                            </div>
                        )}
                        <TournamentTable
                            data={summaryTable?.tableData || []}
                        />
                    </div>
                </TableContainer>
            </Content>
        </div>
    )
}
